import React, { useState } from 'react';
import { Button } from '@hwm/ui-lib';
import { Menu, MenuItem } from '@material-ui/core';
import { Trans } from '@lingui/macro';
import { Clear, Delete, GetApp, GetAppOutlined, MoreVert, Publish } from '@material-ui/icons';
import { useSidebar } from '@shared/hooks';
import { SidebarKeys } from '../../Sidebar.utils';
import { useSelectedSitesDataSource } from '../sitesDataSource';

export const SiteListMenu: React.FC<{ handleDefaultState: () => void }> = ({ handleDefaultState }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { handleSidebarSection } = useSidebar();

  const { selectedSitesList, handleLoadSelectedList, handleUpdateSelectedList, handleRemoveSelectedList } =
    useSelectedSitesDataSource();

  return (
    <>
      <Button
        variant="text"
        style={{ width: 44, minWidth: 44, outline: 'none', height: 32 }}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVert />
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        classes={{ paper: 'p-0' }}
      >
        {selectedSitesList && (
          <MenuItem
            className="hover:text-primaryColor"
            style={{ padding: 12 }}
            onClick={() => {
              handleUpdateSelectedList(selectedSitesList);
              setAnchorEl(null);
            }}
          >
            <GetApp color="primary" className="mr-2" />
            <Trans>Save</Trans> "{selectedSitesList.name}" <Trans>Selected List</Trans>
          </MenuItem>
        )}
        <MenuItem
          className="hover:text-primaryColor"
          style={{ padding: 12 }}
          onClick={() => handleSidebarSection(SidebarKeys.createList)}
        >
          <GetAppOutlined color="primary" className="mr-2" />
          <Trans>Save Selected List As</Trans>
        </MenuItem>
        <MenuItem
          className="hover:text-primaryColor"
          style={{ padding: 12 }}
          onClick={() => handleSidebarSection(SidebarKeys.selectedLists)}
        >
          <Publish color="primary" className="mr-2" />
          <Trans>Load Selected List</Trans>
        </MenuItem>

        {selectedSitesList && (
          <MenuItem
            className="hover:text-primaryColor"
            style={{ padding: 12 }}
            onClick={() => {
              handleRemoveSelectedList(selectedSitesList);
              setAnchorEl(null);
            }}
          >
            <Delete color="primary" className="mr-2" />
            <Trans>Remove</Trans> "{selectedSitesList.name}" <Trans>Selected List</Trans>
          </MenuItem>
        )}
        <MenuItem
          className="hover:text-primaryColor"
          style={{ padding: 12 }}
          onClick={() => {
            handleLoadSelectedList(null, handleDefaultState, true);
            setAnchorEl(null);
          }}
        >
          <Clear color="primary" className="mr-2" />
          <Trans>Clear Selected Sites</Trans>
        </MenuItem>
      </Menu>
    </>
  );
};
